export const Environment = {
  /**
   * @param {"BASE_URL" | "VUE_APP_API_HOST" |  "VUE_APP_API2_HOST" | "VUE_APP_API_MEDIA_HOST" | "VUE_APP_VERSION" | "VUE_APP_ASSETS_URL" | "VUE_APP_FILES_HOST" | "VUE_APP_STRIPE_PUBLISHABLE_KEY" } key
   */
  get: (key) => {
    if (
      globalThis.appConfig["ENABLED"] &&
      globalThis.appConfig[key] !== undefined
    ) {
      return globalThis.appConfig[key];
    }
    return process.env[key];
  },
};
